import { useApplicationContext } from '../../utils/withApplicationContext';

// TODO: Удалить релизный фича-флаг в CD-292428.
/* istanbul ignore next */
export const useOfferBookingFormModalEnabled = () => {
  const { config } = useApplicationContext();

  return config.get<string>('newbuildingBroker.offerBookingFormModalEnabled') ?? false;
};
